import { render } from "./SelectPathologies.vue?vue&type=template&id=38bf5b4c&scoped=true"
import script from "./SelectPathologies.vue?vue&type=script&lang=js"
export * from "./SelectPathologies.vue?vue&type=script&lang=js"

import "./SelectPathologies.vue?vue&type=style&index=0&id=38bf5b4c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/vue-smart-reco-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38bf5b4c"]])

export default __exports__